import { height, width } from '@openeducation/hr-rn-components';
import { useStylesDirection, styledTheme } from '@openeducation/hr-rn-themes';
import { Chart as ChartJS, ArcElement, Tooltip, ChartOptions } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { memo, useMemo } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { View } from 'react-native';

ChartJS.register(ArcElement, Tooltip);

interface ActivitiesPieChartProps {
  labels: string[];
  colors: string[];
  values: number[];
}

const CHART_SIZE = 280;

const ActivitiesPieChart = ({
  labels,
  values,
  colors,
}: ActivitiesPieChartProps) => {
  const { font } = useStylesDirection();
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        displayColors: false,
        yAlign: 'bottom',
        caretPadding: 15,
        callbacks: {
          label: ({ label }: any) => {
            return label;
          },
        },
      },
      datalabels: {
        color: styledTheme.color.white,
        display: 'auto',
        font: {
          size: 14,
          family: font.bold.fontFamily,
        },
      },
    },
  } as ChartOptions<any>;

  const data = useMemo(
    () => ({
      labels,
      datasets: [
        {
          data: values,
          backgroundColor: colors,
          borderColor: colors,
          borderWidth: 1,
        },
      ],
    }),
    [labels, values, colors]
  );

  return (
    <View style={[width(CHART_SIZE), height(CHART_SIZE)]}>
      <Doughnut
        data={data}
        plugins={[ChartDataLabels] as any}
        options={options}
      />
    </View>
  );
};

export default memo(ActivitiesPieChart);
